import React from 'react';
import moment from 'moment';
import { MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem } from 'mdbreact';
import { ContentsDiv, StyledIcon, Normaltd } from '../productTableComponents/styledCard';

 //present the products
const ProductsList = ({ products = [], editedDeviceId, editedDeviceItem, editedDeviceContent, setState, onInfoClick,
  onDropdownClick, onEditButtonClick, onSubmitClick, ontextareaChange, onCancelClick, onRMAToggle }) => {
  let presentedArray =  products.map((value, index) => {
    let rowColor = '';
    if ( value.status === 5 ) {
      rowColor = '#fff8e1';
    } else if (value.status === 1) {
      rowColor = 'rgb(251, 238, 242)';
    };

    return (
      <tr style={{backgroundColor: `${rowColor}`}} key={value._id}>
        <td>{moment(value.createdAt).format('YYYY/MM/DD HH:mm:ss')}</td>
        <td>{value.macAddress}</td>
        <td>{value.serialNumber}</td>
        {/* <td>
          <MDBDropdown>
            <MDBDropdownToggle style={{padding: '0.2rem 0.5rem', height: '1.7rem', boxShadow: 'none'}} caret color="white">
              {value.customer ? value.customer : ``}
            </MDBDropdownToggle>
            <MDBDropdownMenu basic>
              <MDBDropdownItem>{`ABC`}</MDBDropdownItem>
            </MDBDropdownMenu>
          </MDBDropdown>
        </td> */}
        <Normaltd style={{width: '15rem'}} onClick = {(e) => { onEditButtonClick( e, value._id, "location", value.location)}}>
          {
            editedDeviceId === value._id && editedDeviceItem === 'location'
            ? (
              <ContentsDiv>
                <textarea rows={2} onChange={(e) => {ontextareaChange(e)}} value={editedDeviceContent}></textarea>
                <div>
                  <StyledIcon onClick={(e) => {onSubmitClick(e)}} icon="check"/>
                  <StyledIcon className="cancel" onClick={(e) => {onCancelClick(e)}} icon="times"/>
                </div>
              </ContentsDiv>
            )
            : (
              <ContentsDiv>
                <div>{value.location}</div>
              </ContentsDiv>
            )
          }
        </Normaltd>
        {/* <Normaltd style={{width: '15rem'}} onClick = {(e) => {this.onEditButtonClick( e, value._id, "misc", value.prodNotes.misc)}}>
          {
            editedDeviceId === value._id && editedDeviceItem === 'misc'
            ? (
              <ContentsDiv>
                <textarea rows={2} onChange={(e) => {this.ontextareaChange(e)}} value={editedDeviceContent}></textarea>
                <div>
                  <StyledIcon onClick={(e) => {this.onSubmitClick(e)}} icon="check"/>
                  <StyledIcon className="cancel" onClick={(e) => {this.onCancelClick(e, value)}} icon="times"/>
                </div>
              </ContentsDiv>
            )
            : (
              <ContentsDiv>
                <div>{value.prodNotes.misc}</div>
              </ContentsDiv>
            )
          }
        </Normaltd> */}
        <td>
          <MDBDropdown>
            <MDBDropdownToggle style={{padding: '0.2rem 0.5rem', height: '1.7rem'}} caret color="primary">
              {global.gConfig.statusIndex[Number(value.status)]}
            </MDBDropdownToggle>
            <MDBDropdownMenu basic>
              {global.gConfig.statusIndex.map((state, index) => {
                return <MDBDropdownItem key={`Dropdown ${state}`} onClick={(e) => {onDropdownClick(e, value, index)}}>{global.gConfig.statusIndex[index]}</MDBDropdownItem>
              })}
            </MDBDropdownMenu>
          </MDBDropdown>
        </td>
        <Normaltd><StyledIcon onClick={(e) => {onInfoClick(value)}} icon="info"></StyledIcon></Normaltd>
        <Normaltd><StyledIcon onClick={() => {onRMAToggle(value)}} icon="undo"></StyledIcon></Normaltd>
        {/* <Normaltd><StyledIcon onClick={() => {onRMAToggle(value)}} icon="dolly-flatbed"></StyledIcon></Normaltd> */}
      </tr>
    );
  })
  return presentedArray;
};

export default ProductsList;
